import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import tryParseJSON from "../../../helpers/tryParseJSON";

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalProps: PropTypes.shape({
        item: PropTypes.shape({
            DestinationCompany: PropTypes.string,
            ScheduleName: PropTypes.string,
            FlowItemQty: PropTypes.string,
            LayoutName: PropTypes.string,
        }),
        linkFlow: PropTypes.string,
        linkFlowItem: PropTypes.string,
        FlowItemId: PropTypes.number,
        DestinationId: PropTypes.number,
        DeploySetting: PropTypes.number,
        ExportDeploymentFields: PropTypes.string,
    }).isRequired,
};

type ActivationDetailsModalProps = PropTypes.InferProps<typeof propTypes>;

const ActivationDetailsModal: React.FC<ActivationDetailsModalProps> = ({
    isOpen,
    modalProps,
}: ActivationDetailsModalProps) => {
    const dispatch = useDispatch();
    const hide = () => dispatch(hideModal("ACTIVATION_DETAILS"));

    let title;
    let modalText;
    if (modalProps.item != null) {
        title = modalProps.linkFlowItem;
        let jsonObj = tryParseJSON("[" + modalProps.ExportDeploymentFields + "]");
        let jsonArray = jsonObj != null && jsonObj[0] != null ? jsonObj[0][0] : null;
        const jsonContainer =
            jsonArray != null && Object.keys(jsonArray).length ? (
                <>
                    {Object.keys(jsonArray).map(key => (
                        <ListItem key={key}>
                            <ListItemText primary={`${key.replace(/([A-Z])/g, " $1")} :`} secondary={jsonArray[key]} />
                        </ListItem>
                    ))}
                </>
            ) : (
                ""
            );
        modalText = (
            <div className="listForModal">
                <List dense>
                    <ListItem>
                        <ListItemText primary="Flow: " secondary={modalProps.linkFlow} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Item: " secondary={modalProps.linkFlowItem} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Destination: " secondary={modalProps.item.DestinationCompany} />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="Activation Destination Schedule: "
                            secondary={modalProps.item.ScheduleName}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Layout: " secondary={modalProps.item.LayoutName} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Quantity: " secondary={modalProps.item.FlowItemQty} />
                    </ListItem>
                    {jsonObj != null && jsonObj[0] != null && <>{jsonContainer}</>}
                </List>
            </div>
        );
    }

    const modal = (
        <MaterialModal
            title={<span>{title || ""} Activation Template Details</span>}
            isOpen={isOpen}
            onClose={hide}
            id="details-for"
            fullWidth
            maxWidth="xs"
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            {modalText || ""}
        </MaterialModal>
    );

    return modal;
};

export default withModal(ActivationDetailsModal, "ACTIVATION_DETAILS");
